module.exports = __webpack_public_path__ + "static/media/bubble_01.502f932e.jpg";